import axiosInstance from 'shared/services/api/axiosInstance';
import { dedupedGet, invalidateGet } from 'shared/services/api/dedupedGet';

const UNREAD_COUNT_URL = '/notifications/unread-count';

/** Drop the cached badge count. Call after anything that changes it. */
export function invalidateUnreadCount() {
  invalidateGet(UNREAD_COUNT_URL);
}

const notificationService = {
  async getInbox(params = {}) {
    const response = await axiosInstance.get('/notifications', { params });
    return response.data;
  },

  async getUnreadCount() {
    // Deduped, but every write below invalidates it first. The badge's whole
    // job is to be current: a cached count that survives "mark all read" would
    // leave a number sitting next to an empty inbox, which is worse than the
    // duplicate request the cache exists to remove.
    const response = await dedupedGet(UNREAD_COUNT_URL);
    return response.data;
  },

  async markRead(ids = []) {
    const response = await axiosInstance.post('/notifications/mark-read', { ids });
    invalidateUnreadCount();
    return response.data;
  },

  async markAllRead() {
    const response = await axiosInstance.post('/notifications/mark-read', {});
    invalidateUnreadCount();
    return response.data;
  },

  async getPreferences() {
    const response = await axiosInstance.get('/notifications/preferences');
    return response.data;
  },

  async updatePreferences(payload) {
    const response = await axiosInstance.put('/notifications/preferences', payload);
    return response.data;
  },

  async publishUpdate(payload) {
    const response = await axiosInstance.post('/notifications/admin/publish-update', payload);
    return response.data;
  },

  async getAdminHistory(params = {}) {
    const response = await axiosInstance.get('/notifications/admin/history', { params });
    return response.data;
  },
};

export default notificationService;
